var _g, _g2, _rect;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconWallet(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "eNzqPFU7s0K1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    width: 300,
    height: 500,
    rx: 0,
    ry: 0,
    transform: "translate(206 6)",
    fill: "#e7bb42",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("rect", {
    width: 500,
    height: 500,
    rx: 70,
    ry: 70,
    transform: "translate(6 6)",
    fill: "#e7bb42",
    strokeWidth: 0
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    width: 195.793188,
    height: 140,
    rx: 0,
    ry: 0,
    transform: "matrix(1.021486 0 0 1 305.999999 5.153584)",
    fill: "#72788b",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("rect", {
    width: 489.482969,
    height: 140,
    rx: 70,
    ry: 70,
    transform: "matrix(1.021486 0 0 1 6 5.153583)",
    fill: "#72788b",
    strokeWidth: 0
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 130,
    height: 130,
    rx: 0,
    ry: 0,
    transform: "translate(375.903616 241.531131)",
    fill: "#72788b",
    strokeWidth: 0
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWallet);
export default __webpack_public_path__ + "static/media/icon-wallet.ea84202f1a5dc92c385689e78d8c904a.svg";
export { ForwardRef as ReactComponent };